<template>
  <div class="notification-container" v-if="notifications.length">
    <Notification
      v-for="(notification, index) in notifications"
      :index="index"
      :key="`${notification.title}-${index}`"
      :title="$t(notification.title)"
      :message="$t(notification.message)"
      :action="notification.action"
      :type="notification.type"
      :visible="notification.visible"
      @click:close="hideNotification(index)"
    />
  </div>
</template>
<script>
import Notification from '../Notification.vue';
import notifications from '../../mixins/notifications';

export default {
  name: 'Notifications',
  mixins: [notifications],
  components: {
    Notification,
  },
};
</script>
<style lang="scss" scoped>
.notification-container {
  z-index: 100;
  position: fixed;
  max-width: 500px;
  width: calc(100% - 20px);
  top: 10px;
  right: 10px;
}
</style>
